import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentPage: 1,
  currentFilter: "all",
  currentPageSize: 20,
  sortBy: "",
  sortOrder: "",
  search: "",
  showAddItemModal: false,
  showDeleteModal: false,
  clearSelection: false,
  selectedItem: "",
  isEdit: false,
  itemData: [],
};

const itemSlice = createSlice({
  name: "item",
  initialState,
  reducers: {
    updateConfig: (state, action) => {
      action.payload(state);
    },
  },
});

export const { updateConfig } = itemSlice.actions;

export default itemSlice.reducer;
